import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import {InputGroup, Input, Spinner} from 'reactstrap';
import Tooltip from 'components/Tooltip';

export default function SearchInput({onSubmit, value, handleChange, loading, inputPlaceholder, clear, isGetMoreNewsLoading}) {
    const searchChange = (e) => {
        if(e.key === 'Enter') {
            e.preventDefault();
            if(e.target.value.trim() && !isGetMoreNewsLoading) {
                onSubmit();
            }
        } else {
            handleChange(e.target.value);
        }
    };

    return (
        <InputGroup style={{display: 'flex', justifyContent: 'space-between'}}>
            <TextareaAutosize
                placeholder={inputPlaceholder}
                className="search-autosize_textarea"
                value={value}
                onKeyPress={(e) => searchChange(e)}
                onChange={(e) => searchChange(e)}
            />
            <div className="search-input-icon-container">
                {(!isGetMoreNewsLoading && value && value.trim() && !loading) && (
                    <Tooltip placement="bottom" tooltip={`Clear results`} searchInputIcon closeIcon>
                        <i
                            onClick={() => clear()}
                            className="fa fa-times-circle search-input-icon-container--clear"
                        />
                    </Tooltip>
                )}
                {(!isGetMoreNewsLoading && value && value.trim()) && (
                    <Tooltip placement="bottom" tooltip={`Search`} searchInputIcon>
                        <React.Fragment>
                            {loading ? (
                                <Spinner style={{width: '16px', height: '16px', borderWidth: '2px'}}/>
                            ) : (
                                <i
                                    onClick={() => onSubmit()}
                                    className="fa fa-search"
                                />
                            )}
                        </React.Fragment>
                    </Tooltip>
                )}
            </div>
        </InputGroup>
    );
}
